import { Injectable } from '@angular/core';

import { PaymentMethod, RidangoEpic, RidangoReduxAction } from '@ridango/core';

import { ActionsObservable } from 'redux-observable';
import { catchError, map, switchMap } from 'rxjs/operators';

import { PaymentMethodsService } from '../payment-methods.service';
import { PaymentMethodsActions } from './payment-methods.actions';

@Injectable({
    providedIn: 'root',
})
export class PaymentMethodsEpics implements RidangoEpic {
    constructor(private actions: PaymentMethodsActions, private service: PaymentMethodsService) {}

    register() {
        return [this.fetchAllMethods, this.fetchAdyenSession, this.fetchAdyenPaymentStatus];
    }

    fetchAllMethods = (action$: ActionsObservable<any>) =>
        action$.ofType(PaymentMethodsActions.FETCH_START_WITH_EPIC).pipe(
            switchMap((action: RidangoReduxAction) => {
                const cart = action.payload;
                return this.service.fetchAllMethods(cart).pipe(
                    map((response: PaymentMethod[]) => {
                        const allIds = response.map((m) => m.payment_id);
                        let normalized = {};
                        const n = response.map((m) => {
                            normalized = { ...normalized, [m.payment_id]: m };
                            return m;
                        });
                        return this.actions.fetchSuccess({ allIds: allIds, methods: normalized, all: response });
                    }),
                    catchError((e) => [this.actions.fetchFailed(e)])
                );
            })
        );

    fetchAdyenSession = (action$: ActionsObservable<any>) =>
        action$.ofType(PaymentMethodsActions.FETCH_ADYEN_SESSION).pipe(
            switchMap((action: RidangoReduxAction) => {
                return this.service.fetchAdyenSession(action.payload).pipe(
                    map((response) => this.actions.fetchAdyenSessionSuccess(response)),
                    catchError((e) => [this.actions.fetchAdyenSessionFailed(e)])
                );
            })
        );

    fetchAdyenPaymentStatus = (action$: ActionsObservable<any>) =>
        action$.ofType(PaymentMethodsActions.FETCH_ADYEN_PAYMENT_STATUS).pipe(
            switchMap((action: RidangoReduxAction) => {
                return this.service.fetchAdyenPaymentStatus(action.payload).pipe(
                    map((response) => this.actions.fetchAdyenPaymentStatusSuccess(response)),
                    catchError((e) => [this.actions.fetchAdyenPaymentStatusFailed(e)])
                );
            })
        );
}
